import type { ReactNode } from 'react';

import { InsigniaEntorno } from '@/components/InsigniaEntorno';
import { SelectorTema } from '@/components/SelectorTema';

/** Layout del login del panel: el formulario al centro, sin imagen de fondo. */
export function AuthLayout({ children, titulo }: { children: ReactNode; titulo: string }) {
  return (
    <div className="relative flex min-h-dvh flex-col items-center justify-center px-4 py-12">
      <SelectorTema className="absolute top-4 right-4 z-10 text-texto" />
      <main className="w-full max-w-md">
        <img
          src="/img/consalud-horizontal-blanco.png"
          alt="Consalud"
          className="solo-oscuro mx-auto mb-8 h-10 w-auto"
        />
        <img
          src="/img/consalud-horizontal-color.png"
          alt="Consalud"
          className="solo-claro mx-auto mb-8 h-10 w-auto"
        />
        <section className="card-vidrio p-6 sm:p-8">
          <h1 className="text-center text-2xl font-extrabold text-azul-texto">{titulo}</h1>
          <p className="mt-1 mb-6 text-center text-sm text-texto-3">Panel administrativo</p>
          {children}
        </section>
        <p className="mt-6 text-center text-xs text-texto-3">
          © {new Date().getFullYear()} Consalud ENARM
        </p>
      </main>
      <InsigniaEntorno />
    </div>
  );
}

export { Campo } from '@/components/Campo';
